// extracted by mini-css-extract-plugin
export default {"pill":"BriefPill_pill__kaceu","geography":"BriefPill_geography__Aoh91","name":"BriefPill_name__nEdmY","close":"BriefPill_close__+Rbqu","icon":"BriefPill_icon__EMwLl"};